import script from "./FinesRep.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinesRep.vue?vue&type=script&setup=true&lang=ts"

import "./FinesRep.vue?vue&type=style&index=0&id=8a250d3e&lang=css"

const __exports__ = script;

export default __exports__